import React, { FC } from "react";
import { FeeWithDiscount } from "../../Pricing/FeeWithDiscount.csharp";
import classNames from "classnames";
import { formatPrice } from "../Helpers/priceHelper";

interface FeeWithDiscountTableProps {
  heading: string;
  addHadingMargin?: boolean;
  fees: FeeWithDiscount[];
  highlightPriceRowOnHover: boolean;
  getPrice: (fee: FeeWithDiscount) => number;
  getDiscount: (fee: FeeWithDiscount) => number;
  showHeading?: boolean;
}

export const FeeWithDiscountTableLegacy: FC<FeeWithDiscountTableProps> = ({
  heading,
  addHadingMargin,
  fees,
  highlightPriceRowOnHover,
  getPrice,
  getDiscount,
  showHeading = true,
}) => {
  return fees.length > 0 ? (
    <>
      {showHeading && (
        <div
          className={classNames("fw-bold px-2", {
            "mt-2": addHadingMargin,
          })}
        >
          {heading}
        </div>
      )}
      <table className="table">
        <tbody className="no-border">
          {fees.map((fee, i) => {
            const price = getPrice(fee);
            const discount = getDiscount(fee);

            return (
              <tr
                key={i}
                className={classNames("pricing-details-row", {
                  "pricing-details-row-hover":
                    highlightPriceRowOnHover && !fee.applyHeadingStyle,
                })}
              >
                <th
                  className={classNames({
                    "fw-normal": !fee.applyHeadingStyle,
                    "fw-bold mt-2 italic thead-block": fee.applyHeadingStyle,
                  })}
                >
                  {fee.label}
                </th>
                {(price != 0 || fee.useFromPrefix) && (
                  <td className="text-end">
                    {!!discount && (
                      <span className="pricing-details-row__feeOriginPrice">
                        {formatPrice(price)}
                      </span>
                    )}
                    {fee.useFromPrefix
                      ? formatPrice(!!fee.minPrice ? fee.minPrice : price, true)
                      : formatPrice(price - discount)}
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  ) : null;
};
